import React from 'react';
import {Privacy } from './container';

export const PrivacyScreen= ({ navigation }: { navigation: any }) => {
    return <Privacy />
}